import React from 'react';
import DocumentsIcon from '@atlaskit/icon/glyph/documents';
import PersonIcon from '@atlaskit/icon/glyph/person';
import LightbulbIcon from '@atlaskit/icon/glyph/lightbulb';
import FeedbackIcon from '@atlaskit/icon/glyph/feedback';
import { N600 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { getResourceHubUrl, getPartnerSupportUrl } from '@css-xp/ppc-navigation-partner-support-utils';
import { WHAT_IS_NEW_URL } from '@css-xp/ppc-constants';

export const useGetHomeOptions = ({ onClickFeedbackOption }: { onClickFeedbackOption: () => void }) => {
  const partnerServiceDeskOption = {
    id: 'partner-service-desk-iph',
    text: 'Partner Service Desk',
    href: getPartnerSupportUrl(),
    icon: <PersonIcon primaryColor={token('color.icon', N600)} size="medium" label="" />,
  };

  const resourceHubOption = {
    id: 'resource-hub-iph',
    text: 'Resource Hub',
    href: getResourceHubUrl(),
    icon: <DocumentsIcon primaryColor={token('color.icon', N600)} size="medium" label="" />,
  };

  const whatIsNewOption = {
    id: 'what-is-new-iph',
    text: `What's new`,
    href: WHAT_IS_NEW_URL,
    icon: <LightbulbIcon primaryColor={token('color.icon', N600)} size="medium" label="" />,
  };

  const feedbackOption = {
    id: 'give-feedback-iph',
    text: 'Give feedback',
    icon: <FeedbackIcon primaryColor={token('color.icon', N600)} size="medium" label="" />,
    onClick: onClickFeedbackOption,
  };

  return [partnerServiceDeskOption, resourceHubOption, whatIsNewOption, feedbackOption];
};
